import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';

import { Validators, FormBuilder, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/core/services/utils.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { TransactionInvoiceService } from 'src/app/pages/transaction/services/transaction-invoice.service';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { CardFormatterService } from 'src/app/core/services/card-formatter.service';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { CostFormService } from 'src/app/core/services/cost-form.service';
import { CreditService } from 'src/app/pages/credit/credit.service';
import { CreditPurchaseModalComponent } from 'src/app/pages/credit/credit-purchase-modal/credit-purchase-modal.component';
import { Subscription } from 'rxjs';
import { TransactionReceiptModalComponent } from '../transaction-receipt-modal/transaction-receipt-modal.component';
import { UserProcessProfileService } from '../../services/user-process-profile.service';

declare var $: any;
declare var Payment: any;

const PaymentMethod = {
  id: '',
  cardType: '',
  cardName: '',
  number: '',
  expiry: '',
  cvc: '',
  name: '',
  isDefault: ''
};

@Component({
  selector: 'payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentFormComponent extends BaseManagement implements OnInit {

  subscriptions: Subscription[] = [];
  form: FormGroup;
  form1: FormGroup;
  form2: FormGroup;
  formInfo: FormGroup;

  amountToPay: any = 0;
  invoiceNumber: any = 0;

  paymentType: any = 'NA';
  fees: any;
  feeAmount: any = 0;

  costs: any = [];
  costAmount: any = 0;

  gettingFeesAndCosts: any = true;

  totalCost: any = 0;
  additionalCosts: any = [];
  paymentCompleted = false;

  invoiceDescription;
  additionalCost: any = 0;

  invoiceId: any;
  authNumber: any;

  masks: any = [];
  placeholders: any = [];
  messages: any = [];

  cardTypeChangeEvent: any;

  dynamicCosts: any;
  calculatedAmount: any = 0;
  costDetails: any = [];
  paymentPlan = false;
  postalCode;
  profileData;

  radiationMachineCount: number = 0;
  radiationMachineIndividualCost: number = 5;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public dynamicFormService: DynamicFormService,
    private formBuilder: FormBuilder,
    private paymentService: PaymentService,
    public transactionService: TransactionService,
    public translate: TranslateService,
    public transactionInvoiceService: TransactionInvoiceService,
    public multiLanguageService: MultiLanguageService,
    public cardFormatterService: CardFormatterService,
    public costFormService: CostFormService,
    public creditService: CreditService,
    public userProcessProfileService: UserProcessProfileService

  ) {
    super();

    this.form = this.formBuilder.group(
      {
        CardNumber: [
          '',
          Validators.compose([Validators.required, Validators.minLength(17)]),
        ],
        Expiry: [
          '',
          Validators.compose([Validators.required, Validators.minLength(9)]),
        ],
        CVC: ['', Validators.compose([Validators.required])],
        CardType: ['', Validators.compose([Validators.required])],
        NameOnCard: ['', Validators.compose([Validators.required])],
        PaymentAddress: ['', Validators.compose([Validators.required])],
        AccountNumber: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
        RoutingNumber: ['', [Validators.required, Validators.pattern(/^\d{9}$/)]],
        PostalCode: ['', Validators.compose([Validators.required])]
      },
      {
        validator: this.paymentInfoValidation,
      }

    );
    this.form2 = this.formBuilder.group(
      {
        PaymentMethod: [1],

      },
    );
    this.dynamicFormService.isReadOnly = false;

    this.creditService.getBalance();
    if (this.transactionService.itemToEdit.HasDynamicCosts) {

      // tslint:disable-next-line:max-line-length
      this.costFormService.getDynamicCosts(this.paymentService.invoiceToPayId ? this.paymentService.invoiceToPayId : this.transactionService.itemToEdit.InvoiceId)
        .then((data: any) => {
          this.dynamicCosts = data;
          this.costDetails = this.dynamicCosts[0];
          console.log(this.costDetails);
          this.reloadTransactionInvoices();
        });
    }
  }

  isValidCardPayment(): boolean {
    return (
      this.form.get('CardNumber').valid &&
      this.form.get('Expiry').valid &&
      this.form.get('CVC').valid &&
      this.form.get('CardType').valid &&
      this.form.get('NameOnCard').valid &&
      this.form.get('PaymentAddress').valid
    );
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  ngOnInit() {
    console.log('this.transactionService.itemToEdit', this.transactionService.itemToEdit)
    this.userProcessProfileService
    .getUserProcessProfiles(this.transactionService.itemToEdit.Id)
    .then( (data: any) => {
      this.profileData = data.Data.profile[0];
      this.postalCode = this.profileData.PostalCode ? this.profileData.PostalCode : this.profileData.OtherPostalCode;
      console.log('postalCode', this.postalCode)
      this.form.patchValue({
        PostalCode: this.postalCode
      });
    })


    this.cardTypeChangeEvent = this.cardFormatterService.cardTypeChangeEvent.subscribe((paymentType) => {
      this.paymentType = paymentType;

      this.form.patchValue({
        CardType: paymentType,
      });
    });
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit() {
    if (!this.transactionService.itemToEdit.HasDynamicCosts) {
      this.reloadTransactionInvoices();
    }
  }

  onSelectPayMethod(event: any) {
    this.paymentPlan = event.value;
  }

  handleRadioButtonClick(event: MouseEvent, value: number): void {

    this.form2.get('PaymentMethod').setValue(value);

    this.onSelectPayMethod({ value });
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogYesNoComponent, {
      width: '250px',
      data: {
        msg: 'Do you want to implement a payment plan?',
        yesText: 'Yes',
        noText: 'No',
      },
    }).afterClosed().subscribe((res: any) => {
      if (res === 1) {
        this.paymentService.paymentFormIsVisible = false;
        this.paymentService.paymentPlanFormIsVisible = true;
      }
    });
  }

  tryBuyCredit() {
    if (this.isSaving()) { return; }
    this.translate
      .get(['credit.addCredit', 'message.yes', 'message.no'])
      .subscribe((translations) => {
        const dialogRef = this.dialog.open(DialogYesNoComponent, {
          width: '250px',
          data: {
            msg: translations['credit.addCredit'],
            yesText: translations['message.yes'],
            noText: translations['message.no'],
          },
        }).afterClosed().subscribe((res: any) => {
          if (res === 1) {
            this.buyCredit();
          }
        });
      });
  }

  buyCredit() {
    this.translate
      .get(['credit.addCredit', 'message.yes', 'message.no'])
      .subscribe((translations) => {
        const dialogRef = this.dialog.open(CreditPurchaseModalComponent, {
          maxWidth: '100vw',
          maxHeight: '100vh',
          height: '100%',
          width: '100%',
          data: {
            msg: translations['credit.addCredit']
          },

        }).afterClosed().subscribe((res: any) => {
          if (res === 1) {

          }
        });
      });
  }

  reloadTransactionInvoices() {
    this.startSaving('reloading-invoices');

    this.transactionInvoiceService
      .getInvoices(this.transactionService.itemToEdit.Id)
      .then((data: any) => {
        console.log('DATA', data);

        this.setAmountToPay();

        // this.getFees();

        if (this.paymentService.invoiceToPayId === 0) {
          this.invoiceId = 0;
          if (data.length > 0) {
            this.invoiceId = data[0].Id;
          }
        } else {
          this.invoiceId = this.paymentService.invoiceToPayId;
        }
        this.stopSaving();
      });
  }

  formatValue(e) {
    this.cardFormatterService.monitorCcFormat($(e.currentTarget));
  }

  paymentInfoValidation(control: AbstractControl) {
    const cardNumber = control.get('CardNumber').value;
    const expiry = control.get('Expiry').value;

    const pad = (num, size) => {
      num = num.toString();
      while (num.length < size) { num = '0' + num; }

      return num;
    };

    if (expiry.indexOf('/') >= 0 && expiry.length === 9) {
      const expiryArray = expiry.split('/');
      const date = new Date();

      // tslint:disable-next-line:radix
      let expiryMonth = parseInt(expiryArray[0]);
      // tslint:disable-next-line:radix
      const expiryYear = parseInt(expiryArray[1]);
      let currentMonth = date.getMonth() + 1;
      let currentYear = date.getFullYear();


      try {


        const specifiedDate = new Date(expiryYear, expiryMonth);
        const currentDate = new Date();

        expiryMonth = pad(expiryMonth, 2);
        currentMonth = pad(currentMonth, 2);
        currentYear = pad(currentYear, 4);

        if (expiryMonth > 12 || expiryMonth <= 0) {
          this.paymentService.toggleDateFormatError = true;
        }

        console.log('specifiedDate', specifiedDate);
        console.log('currentDate', currentDate);


        if (specifiedDate < currentDate || !specifiedDate) {
          control.get('Expiry').setErrors({ invalidDate: true });
        }
      } catch (e) {
        control.get('Expiry').setErrors({ invalidDate: true });
      }
    } else {
      control.get('Expiry').setErrors({ invalidDate: true });
    }


    return null;
  }

  tryPay() {
    this.translate
      .get(['payment.tryPaySubmit', 'message.yes', 'message.no'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        const dialogRef = this.dialog.open(DialogYesNoComponent, {
          width: '250px',
          data: {
            msg: translations['payment.tryPaySubmit'],
            yesText: translations['message.yes'],
            noText: translations['message.no'],
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result === 1) {
            if (this.transactionService.itemToEdit.Radicated === false) {
              this.payAndSubmit();
            } else {
              this.pay();
            }
          }
        });
      });
  }

  tryPayCredit() {
    this.translate
      .get(['payment.tryPaySubmit', 'message.yes', 'message.no'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        const dialogRef = this.dialog.open(DialogYesNoComponent, {
          width: '250px',
          data: {
            msg: translations['payment.tryPaySubmit'],
            yesText: translations['message.yes'],
            noText: translations['message.no'],
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result === 1) {
            this.payWithCredit();
          }
        });
      });
  }

  payWithCredit() {
    this.translate
      .get(['payment.transactionSuccess', 'payment.serverError'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        this.startSaving('payAndSubmit');

        this.serverError = '';
        this.totalCost = this.amountToPay + this.feeAmount + this.additionalCost;

        if (this.transactionService.itemToEdit.HasDynamicCosts) {
          this.feeAmount = this.dynamicCosts[0].FeeAmount;
          this.totalCost = this.amountToPay + this.feeAmount + this.additionalCost;
        }

        const paymentData = this.setupCreditPaymentData();

        this.creditService
          .payCreditAndSubmit(paymentData, this.transactionService.itemToEdit.Id)
          .then((result: any) => {
            if (result.Success === true) {
              this.transactionService.transactionRefresher.next('refresh-all');

              this.transactionInvoiceService
                .getInvoices(this.transactionService.itemToEdit.Id)
                .then((data) => {
                  this.stopSaving();

                  this.paymentCompleted = true;

                  this.authNumber = data[0].AuthorizationNumber;
                });
            } else {
              this.stopSaving();

              this.serverError = result.Message
                ? result.Message
                : translations['payment.serverError'];
            }
          });
      });
  }
  setupCreditPaymentData() {
    const expiry = this.form.controls.Expiry.value;
    let expiryMonth = 0;
    let expiryYear = 0;

    if (expiry.indexOf('/') >= 0 && expiry.length === 9) {
      const expiryArray = expiry.split('/');
      const date = new Date();

      // tslint:disable-next-line:radix
      expiryMonth = parseInt(expiryArray[0]);
      // tslint:disable-next-line:radix
      expiryYear = parseInt(expiryArray[1]);
    }

    if (this.paymentService.invoiceToPayId) {
      this.invoiceNumber = this.paymentService.invoiceToPayId;
    }
    if (this.costDetails.FeeAmount) {
      this.feeAmount = this.costDetails.FeeAmount;
      this.amountToPay = this.costDetails.TotalAmount;
    }

    const data = {
      CardType: null,
      accountNumber: null,
      amountOfTransaction: this.amountToPay + this.feeAmount + this.additionalCost,
      invoiceNumber: this.invoiceNumber,
      CVV2_CVC2: null,
      expirationMonth: null,
      expirationYear: null,
      name: null,
      feeAmount: this.feeAmount,
      additionalInfo: null,
      zip: null
    };

    return data;
  }


  payAndSubmit() {
    this.translate
      .get(['payment.transactionSuccess', 'payment.serverError'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        this.startSaving('payAndSubmit');

        this.serverError = '';
        this.totalCost = this.amountToPay + this.feeAmount + this.additionalCost;

        if (this.transactionService.itemToEdit.HasDynamicCosts) {
          this.feeAmount = this.dynamicCosts[0].FeeAmount;
          this.totalCost = this.amountToPay + this.feeAmount + this.additionalCost;
        }

        const paymentData = this.setupPaymentData();

        this.paymentService
          .payAndSubmit(paymentData, this.transactionService.itemToEdit.Id)
          .then((result: any) => {
            if (result.Success === true) {
              this.transactionService.transactionRefresher.next('refresh-all');

              this.transactionInvoiceService
                .getInvoices(this.transactionService.itemToEdit.Id)
                .then((data) => {
                  this.stopSaving();

                  this.paymentCompleted = true;

                  this.authNumber = data[0].AuthorizationNumber;
                });
            } else {
              this.stopSaving();

              this.serverError = result.Message
                ? result.Message
                : translations['payment.serverError'];
            }
          });
      });
  }

  pay() {
    this.translate
      .get(['payment.invoiceSuccess', 'payment.serverError'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        this.startSaving('payAndSubmit');

        this.serverError = '';

        const paymentData = this.setupPaymentData();

        this.paymentService
          .pay(paymentData, this.transactionService.itemToEdit.Id)
          .then((result: any) => {
            this.stopSaving();

            if (result.Success === true) {
              const dialogRef = this.dialog.open(DialogYesNoComponent, {
                width: '250px',
                data: {
                  msg: translations['payment.invoiceSuccess'],
                  yesText: 'Ok',
                },
              });

              dialogRef.afterClosed().subscribe(() => {
                this.close();
                this.transactionService.transactionRefresher.next(
                  'refresh-all'
                );
              });
            } else {
              this.serverError = result.Message
                ? result.Message
                : translations['payment.serverError'];
            }
          });
      });
  }

  setupPaymentData() {
    const expiry = this.form.controls.Expiry.value;
    let expiryMonth = 0;
    let expiryYear = 0;

    if (expiry.indexOf('/') >= 0 && expiry.length === 9) {
      const expiryArray = expiry.split('/');
      const date = new Date();

      // tslint:disable-next-line:radix
      expiryMonth = parseInt(expiryArray[0]);
      // tslint:disable-next-line:radix
      expiryYear = parseInt(expiryArray[1]);
    }

    const additionalInfo = this.form.controls.PaymentAddress.value;

    additionalInfo.NameOnCard = this.form.controls.NameOnCard.value;

    const card = this.form.controls.CardNumber.value.substr(
      this.form.controls.CardNumber.value.length - 4
    );

    additionalInfo.LastFourDigits = card;

    console.log(this.paymentService.invoiceToPayId);
    console.log(this.dynamicCosts);
    if (this.paymentService.invoiceToPayId) {
      this.invoiceNumber = this.paymentService.invoiceToPayId;
    }
    if (this.costDetails.FeeAmount) {
      this.feeAmount = this.costDetails.FeeAmount;
      this.amountToPay = this.costDetails.TotalAmount;
    }

    const data = {
      CardType: this.form.controls.CardType.value,
      accountNumber: this.form.controls.CardNumber.value,

      amountOfTransaction: this.amountToPay + this.feeAmount + this.additionalCost,
      invoiceNumber: this.invoiceNumber,
      CVV2_CVC2: this.form.controls.CVC.value,
      expirationMonth: expiryMonth,
      expirationYear: expiryYear,
      name: this.form.controls.NameOnCard.value,
      feeAmount: this.feeAmount,

      additionalInfo: JSON.stringify(additionalInfo),
      zip: this.form.controls.PaymentAddress.value.PostalCode
    };

    return data;
  }

  setupPaymentDataAch() {

    console.log(this.paymentService.invoiceToPayId);
    console.log(this.dynamicCosts);
    if (this.paymentService.invoiceToPayId) {
      this.invoiceNumber = this.paymentService.invoiceToPayId;
    }
    if (this.costDetails.FeeAmount) {
      this.feeAmount = this.costDetails.FeeAmount;
      this.amountToPay = this.costDetails.TotalAmount;
    }

    const data = {
      amountOfTransaction: this.amountToPay + this.feeAmount + this.additionalCost,
      feeAmount: this.feeAmount,
      routingNumber: this.form.controls.RoutingNumber.value,
      accountNumber: this.form.controls.AccountNumber.value,
      zip: this.form.controls.PostalCode.value,
      customerId: this.profileData.Id,
      customerName: (this.profileData.LastName
        ? this.profileData.Name
        : [this.profileData.Name, this.profileData.SecondName, this.profileData.LastName, this.profileData.SecondLastName]
          .filter(name => name && name.trim() !== '')
          .join(' ')),
      customerEmail: this.profileData.Email,
      invoiceNumber: this.invoiceNumber,
      transactionDetail: this.transactionService.itemToEdit.ProcessName
    };

    return data;
  }

  setAmountToPay() {
    if (this.transactionService.itemToEdit) {
      if(this.paymentService.invoiceToPayId > 0){
        const invoice = this.transactionInvoiceService.list.find(i => i.Id == this.paymentService.invoiceToPayId);
        this.invoiceNumber = invoice.Id;
        this.invoiceDescription = invoice.Description
        this.addCosts(invoice);
      }
      else{
        const invoice = this.transactionInvoiceService.list[0];
        this.invoiceNumber = invoice.Id;
        this.addCosts(invoice);
      }

      // this.transactionInvoiceService.list.forEach((invoice, index) => {
      //   // Invoice specified, find that invoice and set amount
      //   if (
      //     this.paymentService.invoiceToPayId > 0 &&
      //     this.paymentService.invoiceToPayId === invoice.Id
      //   ) {
      //     this.amountToPay = invoice.TotalAmount ? invoice.TotalAmount : 0;
      //     this.invoiceNumber = this.paymentService.invoiceToPayId;

      //     this.addCosts(invoice);
      //   } else if (!this.paymentService.invoiceToPayId) {
      //     this.amountToPay = invoice.TotalAmount ? invoice.TotalAmount : 0;
      //     this.invoiceNumber = invoice.Id;

      //     this.addCosts(invoice);
      //   } else {
      //     this.amountToPay = invoice.TotalAmount ? invoice.TotalAmount : 0;
      //     this.addCosts(invoice);
      //   }
      // });
    }
  }

  addCosts(invoice) {
    // Capturar el AdditionalCost del invoice si existe
    this.additionalCost = invoice.AdditionalCost || 0;

    // Calcular el desglose de máquinas de radiación
    if (this.additionalCost > 0) {
      this.radiationMachineCount = Math.floor(this.additionalCost / this.radiationMachineIndividualCost);
    }

    if (
      invoice.CostJson != null
    ) {
      this.additionalCosts = JSON.parse(invoice.CostJson);

      this.amountToPay += this.additionalCosts.total;
    }

    if (
      invoice.CostJson === '{}' || invoice.Costs
    ) {
      this.additionalCosts.costs = invoice.Costs;
      this.amountToPay = 0;
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.additionalCosts.costs.length; i++) {
        if (this.additionalCosts.costs[i].Amount){
          this.amountToPay += (this.additionalCosts.costs[i].Amount * this.additionalCosts.costs[i].Qty);
        }
        else {
          this.amountToPay += this.additionalCosts.costs[i].FixedAmount;
        }
      }
      this.feeAmount = invoice.FeeAmount;
      this.calculatedAmount = invoice.CalculatedTotalAmount ;
      console.log(this.amountToPay);
    }
    if (invoice.CostJson == null) {
      console.log(invoice);
      this.amountToPay = invoice.TotalAmount;
      this.feeAmount = invoice.FeeAmount;
      this.calculatedAmount = invoice.CalculatedTotalAmount;
      if (!this.amountToPay) {
        this.amountToPay = 0;
      }
      if (this.transactionInvoiceService.list) {
        this.additionalCosts.costs = this.transactionInvoiceService.list;
      }

    }

  }

  viewInvoice() {
    this.router.navigate([`/transaction-receipt/${this.invoiceId}`]);
    // this.dialog.open(TransactionReceiptModalComponent, {
    //   maxWidth: '100vw',
    //   maxHeight: '100vh',
    //   height: '100%',
    //   width: '100%',
    //   data: {
    //     Id: this.invoiceId
    //   }
    // });
    this.paymentService.paymentFormIsVisible = false;
  }

  close() {
    this.paymentService.paymentFormIsVisible = false;
  }

  backToTransaction() {
    this.paymentService.paymentFormIsVisible = false;
    this.router.navigate([`/transactions/edit/${this.transactionService.itemToEdit.Id}`]);
  }

  hasRadiationMachines(): boolean {
    return this.additionalCost > 0 && this.radiationMachineCount > 0;
  }

  printFormData() {
    console.log(this.form.value);
  }

  tryPayAch() {
    this.translate
      .get(['payment.tryPaySubmit', 'message.yes', 'message.no'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        const dialogRef = this.dialog.open(DialogYesNoComponent, {
          width: '250px',
          data: {
            msg: translations['payment.tryPaySubmit'],
            yesText: translations['message.yes'],
            noText: translations['message.no'],
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result === 1) {
            this.payAndSubmitAch();
          }
        });
      });
  }

  payAndSubmitAch() {
    this.translate
      .get(['payment.transactionSuccess', 'payment.serverError'])
      .subscribe((translations) => {
        if (this.isSaving()) {
          return false;
        }

        this.startSaving('payAndSubmit');

        this.serverError = '';
        this.totalCost = this.amountToPay + this.feeAmount + this.additionalCost;

        if (this.transactionService.itemToEdit.HasDynamicCosts) {
          this.feeAmount = this.dynamicCosts[0].FeeAmount;
          this.totalCost = this.amountToPay + this.feeAmount + this.additionalCost;
        }

        const paymentData = this.setupPaymentDataAch();
        console.log('paymentData', paymentData)

         this.paymentService
          .payAndSubmitAch(paymentData, this.transactionService.itemToEdit.Id)
          .then((result: any) => {
            if (result.Success === true) {
              this.transactionService.transactionRefresher.next('refresh-all');

              this.transactionInvoiceService
                .getInvoices(this.transactionService.itemToEdit.Id)
                .then((data) => {
                  this.stopSaving();

                  this.paymentCompleted = true;

                  this.authNumber = data[0].AuthorizationNumber;
                });
            } else {
              this.stopSaving();

              this.serverError = result.Message
                ? result.Message
                : translations['payment.serverError'];
            }
          });
      });
  }
}
